import { render, staticRenderFns } from "./BindNew.vue?vue&type=template&id=5b37b002&scoped=true"
import script from "./BindNew.vue?vue&type=script&lang=js"
export * from "./BindNew.vue?vue&type=script&lang=js"
import style0 from "./BindNew.vue?vue&type=style&index=0&id=5b37b002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37b002",
  null
  
)

export default component.exports